import { Navigate } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'

export function PausedSubscription() {
  return <Navigate to={`${routeNames.settings.path}?tab=billing`} replace />
}
